export const LoadingSpinner = () => (
    <div className="ring-green-600 ring-1 bg-green-200 px-4 py-1 text-xs rounded-full">Loading...</div>
  );